import { AUDIO_PERCENTAGES } from "../../../tools/analytics/analytics.types";

/** The share of the media played, 0 to 100, from the player's played chunks. */
export function getPlayedPercent(
  playedChunks: number[][],
  mediaDuration: number
): number {
  if (mediaDuration <= 0) return 0;
  let totalPlayedDuration = 0;
  for (const chunk of playedChunks) {
    const a = chunk.at(0);
    const b = chunk.at(1);
    if (a !== undefined && b !== undefined) {
      totalPlayedDuration += b - a;
    }
  }
  return Math.min(100, (totalPlayedDuration / mediaDuration) * 100);
}

export function getDurationRatioFromPlayedChunks(
  playedChunks: number[][],
  mediaDuration: number
): number {
  const playedRatio = getPlayedPercent(playedChunks, mediaDuration);
  let percentage = 0;
  for (const step of AUDIO_PERCENTAGES) {
    if (playedRatio < step) break;
    percentage = step;
  }
  return percentage;
}
